import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { UnsolicitedCancelLifeCycleEventImpl } from "../model/impl/UnsolicitedCancelLifeCycleEventImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class UnsolicitedCancelLifeCycleEventImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(
    encodable: UnsolicitedCancelLifeCycleEventImpl,
    streamout: CubiqTS.ByteBuffer,
  ): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.eventTypeId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(1),
        false,
        encodable.eventTypeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(2),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.orders != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        true,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(3),
        false,
        encodable.orders,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.benchmarkFg != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(4),
        false,
        encodable.benchmarkFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.sendToAltGrp != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(5),
        false,
        encodable.sendToAltGrp,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateGroupId != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(6),
        false,
        encodable.alternateGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateGroupName != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(7),
        false,
        encodable.alternateGroupName,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.makerName != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(8),
        false,
        encodable.makerName,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "com.bcdfx.api.event.FxLifeCycleEventType"],
    [2, "java.lang.String"],
    [3, "com.bcdfx.model.event.lifecycle.fx.OrderData"],
    [4, "java.lang.Boolean"],
    [5, "java.lang.Boolean"],
    [6, "java.lang.Long"],
    [7, "java.lang.String"],
    [8, "java.lang.String"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(
    encodable: UnsolicitedCancelLifeCycleEventImpl,
    streamin: CubiqTS.ByteBuffer,
  ): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.FxLifeCycleEventType = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.eventTypeId = <CubiqTS.FxLifeCycleEventType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.id = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: Array<CubiqTS.OrderData> = this.baseEncoder.readObject(
            false,
            true,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.orders = <Array<CubiqTS.OrderData>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.benchmarkFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.sendToAltGrp = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.alternateGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.alternateGroupName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.makerName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return UnsolicitedCancelLifeCycleEventImplEncoder.fidTypeMap.has(fid);
  }
}
